import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation } from 'react-query';
import ToastComponent from '../../components/toast';
import { OptionAwardService } from '../../services/wealthlane-award-services';
import { handleOpenFile } from '../../utils/global';

const usePostOptionAdminDashboardGrantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  string | undefined,
  unknown,
  {
    maxResultCount?: number | undefined;
    skipCount?: number | undefined;
    sorting?: string | undefined;
    filter?: string | undefined;
    vestingDate?: string | undefined;
    grantId?: string | undefined;
  },
  unknown
> => {
  return useMutation(
    async (payload: {
      maxResultCount?: number;
      skipCount?: number;
      sorting?: string;
      filter?: string;
      vestingDate?: string;
      grantId?: string;
    }) => {
      return await handleRequest(
        OptionAwardService.postApiAwardApiAppOptionAwardExportAdminDashboardGrantList(payload)
      );
    },
    {
      onSuccess: (response) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message='Exported' />);
          handleOpenFile(`Option-Admin-Dashboard-Grant-List.xlsx`, response ?? '');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostOptionAdminDashboardGrantList;
